import { Capacitor } from "@capacitor/core";
import { LocalNotifications } from "@capacitor/local-notifications";
import Pusher from "pusher-js";
import { useEffect } from "react";
import {actionToGetAllNotification} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

export default function NotificationListener() {
    const {userAuthDetail} = useStore();
    const {userInfo} = userAuthDetail;
    useEffect(() => {
        // Init Pusher
        const pusher = new Pusher("f1ea2bb609b5cc4f717b", {
            cluster: "ap2",
        });

        const channel = pusher.subscribe("notifications-channel");

        channel.bind("notifications-message", async (data) => {
            const message = data.message || "You have a new notification!";
            if(message?.user_id !== userInfo?.id) return;
            actionToGetAllNotification();

            if (Capacitor.isNativePlatform()) {
                // 📱 Native (iOS/Android) → use Local Notifications
                await LocalNotifications.requestPermissions();

                await LocalNotifications.schedule({
                    notifications: [
                        {
                            id: Date.now(),
                            title: "📢 New Message",
                            body: message,
                            smallIcon: "res://ic_launcher", // Android icon
                            iconColor: "#FF4081",
                        },
                    ],
                });

                LocalNotifications.addListener(
                    "localNotificationActionPerformed",
                    (notification) => {
                        console.log("Tapped:", notification);
                        // 🔗 Example navigation
                        window.location.href = "/notifications";
                    }
                );
            } else {
                // 💻 Web / PWA → use Web Notifications API
                if (Notification.permission === "granted") {
                    const notification = new Notification("📢 New Message", {
                        body: message,
                        icon: "/assets/icon/logo.png", // Web app logo
                    });

                    notification.onclick = () => {
                        window.focus();
                        window.location.href = "/notifications";
                    };
                } else {
                    Notification.requestPermission().then((permission) => {
                        if (permission === "granted") {
                            new Notification("📢 New Message", {
                                body: message,
                                icon: "/assets/icon/logo.png",
                            });
                        }
                    });
                }
            }
        });

        return () => {
            channel.unbind_all();
            channel.unsubscribe("my-channel");
            pusher.disconnect();
        };
    }, []);

    return null; // Just a listener, no UI
}
